import { render, staticRenderFns } from "./OPPayableDetailComponent.vue?vue&type=template&id=5496828b&"
import script from "./OPPayableDetailComponent.vue?vue&type=script&lang=js&"
export * from "./OPPayableDetailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports